const INTERNAL_ERROR_CATEGORY = 'INTERNAL_ERROR';
const THIRD_PARTY_OUTAGE_SUB_CATEGORY = 'IntegrationResponse.THIRD_PARTY_OUTAGE';
export const isErrorResponse = integrationResponse => integrationResponse != null && integrationResponse['status'] === 'error';
export const isThirdPartyOutage = integrationResponse => {
  return isErrorResponse(integrationResponse) && integrationResponse['category'] === INTERNAL_ERROR_CATEGORY && integrationResponse['subCategory'] === THIRD_PARTY_OUTAGE_SUB_CATEGORY;
};